export type MoneyCents = number

export function assertIntegerCents(value: number): asserts value is MoneyCents {
  if (!Number.isInteger(value)) throw new Error(`Expected integer cents, got ${value}`)
}

export function roundHalfUp(numerator: number, divisor: number): number {
  return Math.floor((numerator + divisor / 2) / divisor)
}

export function centsToEuros(cents: MoneyCents): number {
  return cents / 100
}

export function formatEuros(cents: MoneyCents): string {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100)
}
